// src/components/Loading.tsx
import React from "react";
import { Container, Spinner } from "react-bootstrap";

export const Loading: React.FC = () => (
  <Container className="py-4 text-center">
    <Spinner animation="border" role="status" />
    <div className="mt-2">Loading…</div>
  </Container>
);